module.exports = __webpack_public_path__ + "img/s4-2.421af319.jpg";